import Container from '@ui/container/container';
import HoverCard from '@ui/cards/hover-card/hover-card';
import PreHoverContent from '@ui/cards/hover-card/pre-hover-content';
import HoverContent from '@ui/cards/hover-card/hover-content';
import Button from '@ui/buttons/button/button';
import Text from '@ui/text/text/text';
import type { LocalCampaignTemplate } from '@/micros/edit-project/grid-areas/main/campaigns/templates';
import TemplateThumbnail from './template-thumbnail';

interface TemplatePreviewCardProps {
  template: LocalCampaignTemplate;
  onEdit: (templateUuid: string) => void;
  onPreview: (templateUuid: string) => void;
  isCreating?: boolean;
}

export default function TemplatePreviewCard({ template, onEdit, onPreview, isCreating }: TemplatePreviewCardProps) {
  return (
    <Container className="flex-column gap-12" data-component="TemplatePreviewCard">
      <HoverCard
        type="fade"
        width="100%"
        aspectRatio="16 / 9"
        containerClassName="radius-12"
        forceHoverState={isCreating}
      >
        <PreHoverContent>
          <TemplateThumbnail templateUuid={template.uuid} />
        </PreHoverContent>

        <HoverContent backgroundColor="rgba(var(--gray-1100-rgb), 0.5)">
          <Container className="flex jc-center ai-center gap-12" height="100%" width="100%">
            <Button
              className="L1"
              backgroundColor="var(--gray-700)"
              hoverBackgroundColor="var(--gray-600)"
              onClick={() => onEdit(template.uuid)}
              borderRadius="100px"
              padding="12px 32px"
              disabled={isCreating}
              loading={isCreating}
            >
              Edit
            </Button>
            <Button
              className="L1"
              backgroundColor="var(--primitives-mode-1-pink-400)"
              hoverBackgroundColor="var(--primitives-mode-1-pink-500)"
              color="var(--gray-true-dark-1200)"
              onClick={() => onPreview(template.uuid)}
              borderRadius="100px"
              padding="12px 32px"
              disabled={isCreating}
            >
              Preview
            </Button>
          </Container>
        </HoverContent>
      </HoverCard>

      <Container maxWidth="100%">
        <Text className="H5" clamp={1} design="GlobalIcoText2">
          {template.title}
        </Text>
      </Container>
    </Container>
  );
}
